import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import { MemberCard } from "@/components/MemberBits";
import { Loader } from "@/components/Guards";

const TABS = [["", "Everyone"], ["sugar_baby", "Sugar Babies"], ["sugar_daddy", "Sugar Daddies"], ["sugar_mommy", "Sugar Mommies"]];

export default function Discover() {
  const [members, setMembers] = useState(null);
  const [role, setRole] = useState("");
  const [q, setQ] = useState("");
  const [country, setCountry] = useState("");
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/members", { params: { role_type: role, q, country, verified } }).then((r) => setMembers(r.data));
    }, 250);
    return () => clearTimeout(t);
  }, [role, q, country, verified]);

  return (
    <main className="mx-auto max-w-7xl px-5 py-12 lg:px-8" data-testid="discover-page">
      <p className="eyebrow mb-3">Discover · worldwide</p>
      <h1 className="font-display mb-10 text-5xl sm:text-6xl">Tonight's <span className="italic text-red-600">company</span></h1>
      <div className="mb-10 flex flex-col gap-4 border-y border-white/5 py-5 lg:flex-row lg:items-center">
        <div className="flex flex-wrap gap-2">
          {TABS.map(([v, l]) => (
            <button key={l} data-testid={`discover-filter-${v || "all"}`} onClick={() => setRole(v)}
              className={`rounded-full px-4 py-2 text-xs uppercase tracking-widest transition-colors ${role === v ? "bg-white text-black" : "text-zinc-400 hover:text-white"}`}>{l}</button>
          ))}
        </div>
        <div className="flex flex-1 flex-wrap items-center gap-3 lg:justify-end">
          <div className="relative"><Search className="absolute left-3 top-3 h-4 w-4 text-zinc-500" />
            <Input data-testid="discover-search-input" placeholder="Name or city" value={q} onChange={(e) => setQ(e.target.value)} className="w-48 bg-zinc-900 pl-9" /></div>
          <Input data-testid="discover-country-input" placeholder="Country" value={country} onChange={(e) => setCountry(e.target.value)} className="w-40 bg-zinc-900" />
          <label className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-400">
            <Switch data-testid="discover-verified-switch" checked={verified} onCheckedChange={setVerified} />Verified
          </label>
        </div>
      </div>
      {members === null ? <Loader /> : members.length === 0 ? (
        <p data-testid="discover-empty" className="py-20 text-zinc-500">No members match these filters yet.</p>
      ) : (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {members.map((m, i) => <MemberCard key={m.id} m={m} i={i} />)}
        </div>
      )}
    </main>
  );
}
